import { render, staticRenderFns } from "./ai-customer-iframe.vue?vue&type=template&id=070825aa&scoped=true&"
import script from "./ai-customer-iframe.vue?vue&type=script&lang=js&"
export * from "./ai-customer-iframe.vue?vue&type=script&lang=js&"
import style0 from "./ai-customer-iframe.vue?vue&type=style&index=0&id=070825aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070825aa",
  null
  
)

export default component.exports